import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as aes from "../utils/aes"
import * as uuid from "../utils/uuid"

/* global MidasCouponApi */
import "es6-promise/auto"

function initCoupon() {
  return new Promise(resolve => {
    if (window.MidasCouponApi) {
      resolve(MidasCouponApi)
    } else {
      request
        .getScript("//midas.gtimg.cn/h5/sdk_v2/coupons/api/midasCouponApi.js")
        .then(() => {
          resolve(MidasCouponApi)
        })
        .catch(e => {
          throw e
        })
    }
  })
}

/**
 * 查券列表
 * @param {*} opts.offerId
 * @param {*} opts.productId 物品ID，券过滤用
 * @param {*} opts.pf
 * @param {*} opts.loginState
 * @param {*} opts.price 价格，券过滤用
 * @param {*} opts.sandbox
 */
export function getCouponsList(opts) {
  let apiParams = {
    pf: opts.pf,
    pfkey: "pfkey",
    from_h5: 1,
    r: Math.random(),
    ...opts.loginState,
    action: "query_valid_sp_coupons",
    curpage: 1,
    sp_status: "COUPON_MULTCOND;1,EFFECT;9,EFFECT",
    pagesize: 20,
    amt: opts.price,
    productid: opts.productId || ""
  }
  apiParams = {
    ...apiParams,
    ...aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], opts.sandbox)
  }

  let env = helper.getCgiEnv(opts.sandbox)

  return request.ajax({
    url: "//" + env + "api.unipay.qq.com/v1/r/" + opts.offerId + "/mobile_coupons_info",
    data: apiParams,
    type: "POST"
  })
}

function getLuckDrawUUid() {
  return `${new Date().getTime()}-${uuid.generate(12).toLowerCase()}`
}
/**
 * 领取抵扣券
 * @param {*} opts.pf
 * @param {*} opts.loginState
 * @param {*} opts.activityNum
 * @param {*} opts.sandbox
 * @param {*} opts.offerId
 */
export function reveiveOneCoupon(opts) {
  let apiParams = {
    pf: opts.pf,
    pfkey: "pfkey",
    from_h5: 1,
    session_token: uuid.generate() + new Date().getTime(),
    r: Math.random(),
    ...opts.loginState,
    action: "receive_coupons",
    coupons_group_id: opts.activityNum,
    present_type: "supercoupon",
    billno: getLuckDrawUUid()
  }
  apiParams = {
    ...apiParams,
    ...aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], opts.sandbox)
  }

  let env = helper.getCgiEnv(opts.sandbox)

  return request.ajax({
    url: "//" + env + "api.unipay.qq.com/v1/r/" + opts.offerId + "/mobile_coupons_info",
    data: apiParams,
    type: "POST"
  })
}

export function getRecommendList(priceList, opts) {
  return initCoupon().then(MidasCouponApi => {
    return new Promise(resolve => {
      let params = helper.extend(
        {
          pf: `${opts.pfSource || "mds_wechat_qb"}-${opts.pf2rd || "pay_html5"}-html5`
        },
        opts
      )

      if (opts.productId) {
        params.productid = opts.productId
      }

      if (opts.isOnlyWechat) {
        params = helper.extend(
          {
            payChannelName: "wechat",
            supportChannel: "wechat"
          },
          params
        )
      } else {
        params = helper.extend(
          {
            normalMode: 1,
            scene: "mall"
          },
          params
        )
      }

      MidasCouponApi.getRecommendList(
        {
          priceList: priceList,
          params: params
        },
        coupons => resolve(coupons)
      )
    })
  })
}

export function openDialog(opts) {
  return initCoupon().then(MidasCouponApi => {
    opts.params = helper.extend(
      {
        pf: `${(opts.params && opts.params.pfSource) || "mds_wechat_qb"}-${(opts.params && opts.params.pf2rd) || "pay_html5"}-html5`
      },
      opts.params
    )

    if (opts.isOnlyWechat) {
      opts.params = helper.extend(
        {
          payChannelName: "wechat",
          supportChannel: "wechat"
        },
        opts.params
      )
    } else {
      opts.params = helper.extend(
        {
          normalMode: 1,
          scene: "mall"
        },
        opts.params
      )
    }

    if (MidasCouponApi.isDestroyed()) {
      MidasCouponApi.launch(opts)
    } else {
      // MidasCouponApi.refresh(opts)
      // MidasCouponApi.show()
      MidasCouponApi.destroy()
      MidasCouponApi.launch(opts)
    }
  })
}

export function hideDialog() {
  initCoupon().then(MidasCouponApi => {
    MidasCouponApi.hide()
  })
}
